module.exports = __webpack_public_path__ + "img/bannerformcopy.dca5a6b6.png";